export const GET_ANOMALY_INCIDENTS = 'get-anomaly-incidents';
